module.exports = __webpack_public_path__ + "02678d4220b222701a93d5e56de18e30.png";